import { Icon } from "@sportal/cdk";

import "./Icon.scss";

export { Icon };
